//----- Component --------------------------------------------------------/

// Developer : Daiana Curcio / Nicolas Pascucci

// Creation Date : 3/1/2024

// Version : 1

// Description : Historial de consumo con importación a CSV
//

//------Changes --------------------------------------------------------------------- -------------//

// Change Date :

// Change by :

// Change description:

//

// Change Date :

// Change by :

// Change description:

//
//========================================================================/

import React, { useState, useEffect, useMemo } from "react";
import { UrlApi } from "../../services/apirest";
import MaterialReactTable, {
  MRT_FullScreenToggleButton,
} from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es"; //Tabla en español
import { Box, Typography, Grid } from "@mui/material";
import { ThemeProvider } from "@mui/material";
// Boton desplegable
import Button from "@mui/material/Button";
//CSV
import { ExportToCsv } from "export-to-csv";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { blueGrey } from "@mui/material/colors";

function Historial_consumo(props) {
  //CSV CONSUMO
  const [consumoCSV, setConsumoCSV] = useState();

  const obtenerConsumoCSV = () => {
    fetch(UrlApi + "/stock_transacciones/consumoCSV/" + props.sucursal)
      .then((data) => data.json())
      .then((data) => setConsumoCSV(data));
  };

  //funcion que espera los cambios de la funcion
  useEffect(() => {
    obtenerConsumoCSV();
  }, []);

  useEffect(() => {
    if (consumoCSV && consumoCSV.length > 0) {
      const consumosOrdenados = consumoCSV.sort(
        (a, b) => new Date(b.fecha_transaccion) - new Date(a.fecha_transaccion)
      );
      setConsumoCSV([...consumosOrdenados]); // Actualiza el estado con el array ordenado
    }
  }, [consumoCSV]);
  //************************************************************************************************************************************************ */
  const columns8 = useMemo(
    // TABLA CONSUMO
    () => [
      {
        header: "Fecha",
        accessorKey: "fecha_transaccion",
        size: 60,
        type: "date",
        format: "YYYY-MM-DD HH:mm",
      },
      { header: "Artículo", accessorKey: "nombre_articulo", size: 110 },
      {
        header: "Almacén de Origen",
        accessorKey: "almacen_nombre_origen",
        size: 100,
      },
      {
        header: "Cantidad Consumida",
        accessorKey: "cantidad_enviada",
        size: 100,
        enableHiding: true,
      },
    ],
    []
  );

  const columnsConsumoCSV = useMemo(
    // TABLA CONSUMO CSV
    () => [
      { header: "Artículo", accessorKey: "nombre_articulo", size: 110 },
      {
        header: "Almacén de Origen",
        accessorKey: "almacen_nombre_origen",
        size: 100,
      },
      {
        header: "Cantidad Consumida",
        accessorKey: "cantidad_enviada",
        size: 100,
        enableHiding: true,
      },
      {
        header: "Fecha",
        accessorKey: "fecha_transaccion",
        size: 60,
        type: "date",
        format: "YYYY-MM-DD HH:mm",
      },
      { header: "Usuario", accessorKey: "usuario", size: 75 },
    ],
    []
  );
  //************************************************************************************************************************************************ */
  //CSV CONSUMO
  const csvOptionsConsumo = {
    fieldSeparator: ",",
    quoteStrings: '"',
    decimalSeparator: ".",
    showLabels: true,
    useBom: true,
    useKeysAsHeaders: false,
    filename: `Historial de Consumos de Artículos de la Sucursal ${props.nombreSuc}`,
    headers: columnsConsumoCSV.map((c) => c.header),
  };
  const csvExporterConsumo = new ExportToCsv(csvOptionsConsumo);

  const handleExportDataConsumo = () => {
    csvExporterConsumo.generateCsv(consumoCSV);
  };

  return (
    <div>
      <Box mt={2} mb={4}>
        <ThemeProvider theme={props.tableTheme}>
          <MaterialReactTable
            enableExpandAll={false}
            enableToolbarInternalActions={true} //las acciones al lado del search (agregar y full screen)
            enableGrouping // para permitir agrupar x estado x ej
            layoutMode="grid"
            muiTableHeadCellProps={props.tableHeadCellProps}
            muiTableBodyCellProps={({ row }) => ({
              align: "left",
              sx: {
                color: "black",
                borderColor: "black",
              },
            })}
            enableColumnActions={true} //los puntitos de al lado de los titulos (acciones) -> hay que activarlo para agrupar x estado x ej
            enableColumnFilters={false} //desactiva filtros x  columna
            enableHiding={false} // opcion de ocultar columna pero activando el enablecolumaction
            enableDensityToggle={false} //
            localization={MRT_Localization_ES} //idioma
            enableColumnDragging={false} //para arrastrar columnas
            initialState={props.initialState}
            muiSearchTextFieldProps={props.muiSearchTextFieldProps}
            columns={columns8}
            data={props.consumo} //con lo q la completas (esto cambia siempre)
            enableStickyFooter
            // enableEditing
            positionActionsColumn="last" // posicion de la columna de acciones al final
            // ACCIONES
            renderToolbarInternalActions={(
              { table } // boton para nuevo , al lado del buscar
            ) => (
              <>
                <Grid item xs={6} ml={4}>
                  <Button
                    variant="contained"
                    color="primary"
                    endIcon={<FileDownloadIcon />}
                    onClick={handleExportDataConsumo}
                    style={{
                      backgroundColor: blueGrey[700],
                      color: "white",
                    }}
                    size="small"
                  >
                    Exportar a CSV
                  </Button>
                </Grid>
                <MRT_FullScreenToggleButton table={table} />
              </>
            )}
            renderTopToolbarCustomActions={() => (
              <>
                <Typography variant="poster" fontSize={26}>
                  Consumo de Artículos
                </Typography>
              </>
            )}
          />
        </ThemeProvider>
      </Box>
    </div>
  );
}

export default Historial_consumo;
